export var isNoteSetupAppointment = function (appointment) {
    return !!appointment.member;
};
